import { CLOSE_MODAL } from 'app/modal/actions/index';

const closeModal = () => ({
  type: CLOSE_MODAL
});

export default closeModal;
